module.exports = __webpack_public_path__ + "static/staticContentNo-497171df376ea1fcda356c9c4e80a5ae.png";